import _jsx from "@babel/runtime/helpers/jsx";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _dec3, _class, _class2, _CircularProgressGree;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import Popover from '@mui/material/Popover';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import AppContext from '../../../context';
import * as lessonDetailsActions from '../../../actions/lessonDetails';
import CircularProgressGreen from '../../../components/CircularProgressGreen';
import { isTrial } from '../../../helpers';
import messages from '../lessonDetailsMessages';
import s from './VideoNotePopover.scss';
import textFieldStyles from '../../../components/styles/TextField.scss';
import intlPropTypes from '../../../constants/intlPropTypes';
var VideoNotePopover = (_dec = withStyles(s), _dec2 = withStyles(textFieldStyles), _dec3 = connect(function (state) {
  return {
    auth: state.auth,
    lesson: state.lessonDetails.lesson,
    videoNotes: state.lessonDetails.videoNotes,
    course: state.courseDetails.course,
    lang: state.intl.locale
  };
}, function (dispatch) {
  return bindActionCreators({
    getLessonVideoNotes: lessonDetailsActions.getLessonVideoNotes
  }, dispatch);
}), injectIntl(_class = _dec(_class = _dec2(_class = _dec3(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(VideoNotePopover, _React$Component);
  var _super = _createSuper(VideoNotePopover);
  function VideoNotePopover() {
    var _this;
    _classCallCheck(this, VideoNotePopover);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isVideoNoteSaving: false,
      showIsVideoNoteAddedSnackBar: false,
      videoNote: {
        isPrivate: true
      }
    });
    _defineProperty(_assertThisInitialized(_this), "addVideoNote", function () {
      var _this$props = _this.props,
        lessonId = _this$props.lesson._id,
        videoNotes = _this$props.videoNotes,
        getLessonVideoNotes = _this$props.getLessonVideoNotes,
        courseId = _this$props.course._id,
        handleVideoNotePopoverClose = _this$props.handleVideoNotePopoverClose,
        videoNoteTime = _this$props.videoNoteTime;
      var videoNote = _this.state.videoNote;
      var max = _.max(_.map(videoNotes, 'order'));
      var order = _.isNumber(max) ? max + 1 : 0;
      _this.setState({
        isVideoNoteSaving: true
      });
      return _this.context.fetch("/api/courses/".concat(courseId, "/video-notes/").concat(lessonId), {
        method: 'PUT',
        body: JSON.stringify([].concat(_toConsumableArray(videoNotes), [_objectSpread(_objectSpread({}, videoNote), {}, {
          order: order,
          time: videoNoteTime
        })]))
      }).then(function (res) {
        if (res.ok) {
          _this.setState({
            videoNote: {
              isPrivate: true
            },
            showIsVideoNoteAddedSnackBar: true,
            isVideoNoteSaving: false
          });
          handleVideoNotePopoverClose();
          getLessonVideoNotes(courseId, lessonId);
        }
      })["catch"](function (error) {
        _this.setState({
          isVideoNoteSaving: false
        });
        console.error(error);
      });
    });
    return _this;
  }
  _createClass(VideoNotePopover, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        isAddVideoNoteOpen = _this$props2.isAddVideoNoteOpen,
        formatMessage = _this$props2.intl.formatMessage,
        videoNoteAnchorEl = _this$props2.videoNoteAnchorEl,
        videoNoteTime = _this$props2.videoNoteTime,
        handleVideoNotePopoverClose = _this$props2.handleVideoNotePopoverClose,
        auth = _this$props2.auth;
      var _this$state = this.state,
        isVideoNoteSaving = _this$state.isVideoNoteSaving,
        videoNote = _this$state.videoNote,
        showIsVideoNoteAddedSnackBar = _this$state.showIsVideoNoteAddedSnackBar;
      return /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Popover, {
        open: isAddVideoNoteOpen,
        anchorEl: videoNoteAnchorEl,
        anchorReference: "anchorEl",
        onClose: handleVideoNotePopoverClose,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        classes: {
          paper: s.videoNotePopover
        }
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.addNotePopoverContent
      }, void 0, /*#__PURE__*/_jsx(TextField, {
        rows: 5,
        rowsMax: 5,
        InputProps: {
          classes: {
            root: textFieldStyles.textField,
            input: textFieldStyles.textFieldInput,
            error: textFieldStyles.textFieldError,
            focused: textFieldStyles.textFieldFocused,
            disabled: textFieldStyles.textFieldDisabled
          }
        },
        inputProps: {
          maxLength: 150,
          'aria-label': formatMessage(messages.videoCommentAriaLabel)
        },
        label: formatMessage(messages.leaveCommentLabel, {
          time: moment(1000 * videoNoteTime).format('mm:ss')
        }),
        InputLabelProps: {
          shrink: true
        },
        value: videoNote.text,
        onChange: function onChange(_ref) {
          var value = _ref.target.value;
          return _this2.setState(function (prevState) {
            return {
              videoNote: _objectSpread(_objectSpread({}, prevState.videoNote), {}, {
                text: value
              })
            };
          });
        },
        fullWidth: true,
        multiline: true
      }), /*#__PURE__*/_jsx("div", {
        className: classNames(s.flex, s.spaceBetween)
      }, void 0, /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(isTrial(auth) ? messages.optionIsNotAvailableForTrial : messages.privateLabel)
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.privateContainer
      }, void 0, /*#__PURE__*/_jsx(FormControlLabel, {
        control: /*#__PURE__*/_jsx(Checkbox, {
          color: "primary",
          checked: videoNote.isPrivate,
          name: "isPrivate",
          disabled: isTrial(auth),
          onChange: function onChange() {
            return _this2.setState({
              videoNote: _objectSpread(_objectSpread({}, videoNote), {}, {
                isPrivate: !videoNote.isPrivate
              })
            });
          }
        }),
        className: s.addNotesCheckBox,
        label: formatMessage(messages.privateLabel)
      }))), /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx("span", {
        className: classNames(s.actionButtonWrapper, s.addNotesSaveBtnWrap)
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "Nx4GjYMLIF7TW_pThZTB4",
        variant: "contained",
        className: s.addNotesSaveBtn,
        onClick: handleVideoNotePopoverClose
      }, void 0, _.capitalize(formatMessage(messages.close)))), /*#__PURE__*/_jsx("span", {
        className: classNames(s.actionButtonWrapper, s.addNotesSaveBtnWrap)
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "9gwW0H5KZurHm8bf8Z77G",
        variant: "contained",
        color: "primary",
        disabled: !videoNote.text || !videoNote.text.trim() || isVideoNoteSaving,
        className: s.addNotesSaveBtn,
        onClick: this.addVideoNote
      }, void 0, isVideoNoteSaving ? /*#__PURE__*/React.createElement(FormattedMessage, messages.savingLabel) : /*#__PURE__*/React.createElement(FormattedMessage, messages.saveLabel), isVideoNoteSaving && (_CircularProgressGree || (_CircularProgressGree = /*#__PURE__*/_jsx(CircularProgressGreen, {
        size: 24
      }))))))), /*#__PURE__*/_jsx(FormHelperText, {
        className: s.privateCheckboxHint
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.privateCheckboxHint)))), /*#__PURE__*/_jsx(Snackbar, {
        open: showIsVideoNoteAddedSnackBar,
        onClose: function onClose() {
          return _this2.setState({
            showIsVideoNoteAddedSnackBar: false
          });
        },
        autoHideDuration: 1000,
        message: formatMessage(messages.noteSuccessAddMsg)
      }));
    }
  }]);
  return VideoNotePopover;
}(React.Component), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class) || _class);
export { VideoNotePopover as default };